









































import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { Contact } from "../../services/contact/entities/contact.interface";

@Component
export default class DeletecontactDialog extends Vue {
  @Prop() contact!: Contact;
  @Prop() dialogDelete!: boolean;

  loadingDelete = false;

  cancelDelete(): void {
    this.$emit("cancelDelete");
  }

  async removecontact() {
    this.loadingDelete = true;
    try {
      const response = await this.$store.dispatch("contact/deleteContact", {
        contactID: this.contact.contactID,
      });
      if (response) {
        this.$emit("onSuccess");
      } else {
        this.$emit("onError");
      }
    } catch (error) {
      this.$emit("onError");
    }

    this.loadingDelete = false;
    this.$emit("cancelDelete");
  }
}
